import { useIsFetching, useIsMutating } from '@tanstack/react-query';
import { useRouterState } from '@tanstack/react-router';
import { useEffect, useState } from 'react';
import { cn } from '@/lib/utils';

/**
 * A thin bar across the top of the window while a screen opens, its data loads or something is being saved — so a
 * slow screen never looks frozen. Shown only after 150 ms (quick loads stay calm) and faded out when done.
 */
export function TopProgress() {
  const routing = useRouterState({ select: (s) => s.status === 'pending' });
  // First loads only: background refreshes (live counts every few minutes) must not flash the bar.
  const fetching = useIsFetching({ predicate: (q) => q.state.data === undefined });
  const saving = useIsMutating();
  const busy = routing || fetching > 0 || saving > 0;
  const [show, setShow] = useState(false);
  useEffect(() => {
    if (!busy) {
      const t = setTimeout(() => setShow(false), 180);
      return () => clearTimeout(t);
    }
    const t = setTimeout(() => setShow(true), 150);
    return () => clearTimeout(t);
  }, [busy]);
  return (
    <div aria-hidden className={cn('pointer-events-none fixed inset-x-0 top-0 z-[100] h-[3px] overflow-hidden transition-opacity duration-300', show ? 'opacity-100' : 'opacity-0')}>
      <div className="fx-progress h-full w-full bg-linear-to-r from-transparent via-primary to-accent shadow-[0_0_10px_var(--color-accent)]" />
    </div>
  );
}
